import { createElementObject, createOverlayComponent } from '@react-leaflet/core';
import { Tooltip as LeafletTooltip } from 'leaflet';
import { useEffect } from 'react';
export var Tooltip = createOverlayComponent(function createTooltip(props, context) {
  var tooltip = new LeafletTooltip(props, context.overlayContainer);
  return createElementObject(tooltip, context);
}, function useTooltipLifecycle(element, context, _ref, setOpen) {
  var position = _ref.position;
  useEffect(function addTooltip() {
    var container = context.overlayContainer;
    if (container == null) {
      return;
    }
    var instance = element.instance;
    var onTooltipOpen = function onTooltipOpen(event) {
      if (event.tooltip === instance) {
        if (position != null) {
          instance.setLatLng(position);
        }
        instance.update();
        setOpen(true);
      }
    };
    var onTooltipClose = function onTooltipClose(event) {
      if (event.tooltip === instance) {
        setOpen(false);
      }
    };
    container.on({
      tooltipopen: onTooltipOpen,
      tooltipclose: onTooltipClose
    });
    container.bindTooltip(instance);
    return function removeTooltip() {
      container.off({
        tooltipopen: onTooltipOpen,
        tooltipclose: onTooltipClose
      });
      // @ts-ignore protected property
      if (container._map != null) {
        container.unbindTooltip();
      }
    };
  }, [element, context, setOpen, position]);
});